import { service } from '@ember/service';
import Controller from '@ember/controller';

export default class NotFoundController extends Controller {
  @service currentPractice;
}
